import type { FunctionComponent, ReactElement } from 'react';

import { useMcpOptionalSitesFlow } from './useMcpConsentFlow';
import McpFlowParameters from '../MCP/McpFlowParameters';
import OptionalSitesFlowParameters from './McpFlowParameters';

/**
 * The hidden form parameters MCP submits on Accept, for the flow the
 * MCP_OPTIONAL_SITES gate selects. See useMcpOptionalSitesFlow.
 */
const McpFlowParametersSwitch: FunctionComponent = (): ReactElement =>
  useMcpOptionalSitesFlow() ? (
    <OptionalSitesFlowParameters />
  ) : (
    <McpFlowParameters />
  );

export default McpFlowParametersSwitch;
